var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgToolbarAt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "at-sign",
    clipPath: "url(#clip0_0_6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.0002 5.99976V9.75006C12.0002 10.3468 12.2373 10.9192 12.6593 11.3412C13.0813 11.7632 13.6536 12.0002 14.2504 12.0002C14.8472 12.0002 15.4195 11.7632 15.8415 11.3412C16.2635 10.9192 16.5006 10.3468 16.5006 9.75006V9C16.5006 7.31035 15.9301 5.67019 14.8815 4.34526C13.833 3.02033 12.3677 2.08826 10.7233 1.70005C9.07883 1.31185 7.35147 1.49026 5.82108 2.20638C4.29068 2.92249 3.04691 4.13436 2.29127 5.64563C1.53563 7.15691 1.3124 8.87905 1.65775 10.533C2.00309 12.187 2.89678 13.676 4.19402 14.7586C5.49125 15.8412 7.11604 16.4542 8.80512 16.4981C10.4942 16.542 12.1486 16.0143 13.5004 15.0005M12.0002 9C12.0002 10.657 10.657 12.0002 9 12.0002C7.34301 12.0002 5.99976 10.657 5.99976 9C5.99976 7.34301 7.34301 5.99976 9 5.99976C10.657 5.99976 12.0002 7.34301 12.0002 9Z",
    stroke: "#6B7280",
    strokeWidth: 1.75,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_6"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToolbarAt);
export default __webpack_public_path__ + "static/media/toolbar-at.fc1d994f514fade98dbe0dd15aa41376.svg";
export { ForwardRef as ReactComponent };